export const GET_NODE_STATUS = 'rx/GET_NODE_STATUS';
export const GET_NODE_STATUS_SUCCESS = 'rx/GET_NODE_STATUS_SUCCESS';
export const GET_NODE_STATUS_ERROR = 'rx/GET_NODE_STATUS_ERROR';
export const TIMER_START = 'rx/TIMER_START';
export const TIMER_STOP = 'rx/TIMER_STOP';
export const INTERVAL_GET = 'rx/INTERVAL_GET';
export const GET_SIGNAL = 'rx/GET_SIGNAL';
export const GET_SIGNAL_SUCCESS = 'rx/GET_SIGNAL_SUCCESS';
export const GET_TRAFFIC = 'rx/GET_TRAFFIC';
export const GET_TRAFFIC_SUCCESS = 'rx/GET_TRAFFIC_SUCCESS';
export const GET_INTERNET_STATUS = 'rx/GET_INTERNET_STATUS';
export const GET_INTERNET_STATUS_SUCCESS = 'rx/GET_INTERNET_STATUS_SUCCESS';